import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_SPECIALTY_LIST_REQUESTED,
  GET_SPECIALTY_LIST_SUCCESS,
  GET_SPECIALTY_LIST_FAILURE,
  GET_AREA_OF_FOCUS_SUCCESS,
  GET_AREA_OF_FOCUS_FAILURE,
  GET_AREA_OF_FOCUS_REQUESTED,
  GET_LOCATION_REQUESTED,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_FAILURE,
  FIND_PROVIDERS_REQUESTED,
  FIND_PROVIDERS_SUCCESS,
  FIND_PROVIDERS_FAILURE,
  SEARCH_FOR_PROVIDER_ERRORS,
  SERVER_ERROR_FAILURE,
  SERVER_ERROR_SUCCESS,
} from '../constants/constant.action'
import { api } from '../services'

function* getSpecialtyListSaga(action) {
  try {
    const result = yield call(api.getSpecialtyList, action.payload)
    yield put({
      type: GET_SPECIALTY_LIST_SUCCESS,
      payload: result.data,
    })
  } catch (error) {
    yield put({ type: GET_SPECIALTY_LIST_FAILURE, error })
  }
}

function* getAreaOfFocusSaga(action) {
  try {
    const result = yield call(api.getAreaOfFocus, action.payload)
    yield put({
      type: GET_AREA_OF_FOCUS_SUCCESS,
      payload: result.data.resultObject,
    })
  } catch (error) {
    yield put({ type: GET_AREA_OF_FOCUS_FAILURE, error })
  }
}

function* getLocationSaga(action) {
  try {
    const result = yield call(api.getLocation, action.payload)
    yield put({ type: GET_LOCATION_SUCCESS, payload: result })
  } catch (error) {
    yield put({ type: GET_LOCATION_FAILURE, error })
  }
}

function* findProviderSaga(action) {
  try {
    const payload = {
      timestamp: new Date().getTime(),
      checkTooBig: true,
      ...action.payload,
    }

    const reqParam = Object.keys(payload)
      .filter(item => payload[item])
      .map(item => `${item}=${payload[item]}`)
      .join('&')
    const result = yield call(api.findProviders, reqParam)

    if (result.hasOwnProperty('response') && result.response.status === 404) {
      yield put({
        type: SEARCH_FOR_PROVIDER_ERRORS,
        payload: result.response.data.error.message,
      })
      return
    }
    // yield put({
    //   type: FIND_PROVIDERS_SUCCESS,
    //   payload: result.data.resultObject
    // });

    // let { providerList } = result.data.resultObject;
    // if (providerList && providerList.length > 100) {
    //   providerList.splice(100);
    // }
    if (result.data.length > 0) {
      yield put({
        type: FIND_PROVIDERS_SUCCESS,
        payload: {
          providerList: result.data,
          distance: action.payload.distance,
        },
      })
    }

    // const filteredByName = result.data.resultObject.providerList.filter(item => item.providerNameTitle.indexOf(this.props.firstName) !== -1 && item.providerNameTitle.indexOf(this.props.lastName) !== -1)

    if (result.data.length === 0) {
      const { firstname, lastname, npi } = action.payload
      let message
      if (firstname && lastname) {
        message = `Sorry we couldn't find results matching ${firstname} ${lastname}`
      } else if (npi !== '') {
        message = `Sorry we couldn't find results matching ${npi}`
      } else {
        message =
          "Sorry we couldn't find results matching your search criteria."
      }

      while (action.payload.distance != '50') {
        yield put({
          type: FIND_PROVIDERS_REQUESTED,
          payload: {
            ...action.payload,
            distance: action.payload.distance + 10,
          },
        })
      }
      yield put({ type: SEARCH_FOR_PROVIDER_ERRORS, payload: message })
    }
  } catch (error) {
    yield put({ type: FIND_PROVIDERS_FAILURE, error })
  }
}

export function* getSpecialtyListWatcherSaga() {
  yield takeLatest(GET_SPECIALTY_LIST_REQUESTED, getSpecialtyListSaga)
}

export function* getAreaOfFocusWatcherSaga() {
  yield takeLatest(GET_AREA_OF_FOCUS_REQUESTED, getAreaOfFocusSaga)
}

export function* getLocationWatcherSaga() {
  yield takeLatest(GET_LOCATION_REQUESTED, getLocationSaga)
}

export function* findProviderWatcherSaga() {
  yield takeLatest(FIND_PROVIDERS_REQUESTED, findProviderSaga)
}
